import axios from 'axios';

// Variable para almacenar la función de obtener token
let globalGetTokenFn = null;

// Función para configurar el proveedor de token global
export const setGlobalTokenProvider = (tokenProvider) => {
  globalGetTokenFn = tokenProvider;
  console.log('🔧 Configurado proveedor de token global para todas las instancias de axios');
};

// Configurar interceptor global para todas las instancias de axios
const setupGlobalInterceptors = () => {
  // Interceptor de REQUEST global
  axios.interceptors.request.use(
    (config) => {
      try {
        // Solo añadir token si no está ya presente
        if (!config.headers.Authorization && globalGetTokenFn && typeof globalGetTokenFn === 'function') {
          const token = globalGetTokenFn();
          console.log('🔍 Debug token global:', {
            url: config.url,
            tokenFunction: !!globalGetTokenFn,
            tokenValue: token,
            tokenType: typeof token,
            hasExistingAuth: !!config.headers.Authorization
          });
          
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            console.log('🔐 Token global añadido a axios request:', config.url);
          } else {
            console.log('⚠️ Token global es null/undefined para:', config.url);
          }
        } else if (config.headers.Authorization) {
          console.log('ℹ️ Request ya tiene Authorization header:', config.url);
        } else {
          console.log('⚠️ globalGetTokenFn no configurado para:', config.url);
        }
      } catch (error) {
        console.error('❌ Error al obtener token global:', error);
      }
      
      return config;
    },
    (error) => {
      console.error('❌ Error en interceptor global de request:', error);
      return Promise.reject(error);
    }
  );

  // Interceptor de RESPONSE global
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        const { status } = error.response;
        
        if (status === 401) {
          console.error('🔒 Error global 401: Token inválido o expirado');
        } else if (status === 403) {
          console.error('🚫 Error global 403: Acceso denegado');
        }
      }
      
      return Promise.reject(error);
    }
  );

  console.log('✅ Interceptores globales de axios configurados');
};

// Configurar interceptores al importar este módulo
setupGlobalInterceptors();

export default setupGlobalInterceptors; 